export const ActionType = {
  GetList: Symbol("GetHomeList"),
  Create: Symbol("CreateHome"),
  Update: Symbol("UpdateHome"),
  UpdateStatus: Symbol("UpdateHomeStatus"),
  Delete: Symbol("DeleteHome"),
};
